import React, { useState } from "react";
import { FaInstagram, FaWhatsapp, FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";
import selo1 from '@/assets/selo1.png';
import selo2 from '@/assets/selo2.png';
import selo3 from '@/assets/selo3.jpg';
import logo from '@/assets/fundo-rodape.png';
import FaixaComLaco from '@/components/FaixaComLaco';

const Rodape = () => {
  const [] = useState(false);

  return (
    <>
      {/* Barra azul decorativa */}
      <div className="w-4/5 max-w-4xl mx-auto">
  {/* Faixa dourada */}
  <div className="h-1 bg-gradient-to-r from-[#d4b17d] via-[#c9aa7b] to-[#a8805a] rounded-full" />

  {/* Linha branca logo abaixo */}
  <div className="h-[2px] bg-white mt-1 rounded-full" />
</div>

      <footer className="text-white pt-12 pb-6 relative" style={{ backgroundColor: "#C9AA7B" }}>
        <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-3 gap-10">
          {/* Logo e slogan */}
          <div className="text-center md:text-left flex flex-col items-center md:items-start">
  <img src={logo} alt="Master Clean" className="h-20 lg:h-28 xl:h-32 mb-2" />
  <p className="text-sm lg:text-base text-white font-medium tracking-wide leading-snug mt-1 text-center md:text-left">
   Higienização de estofados em geral
  </p>
</div>


          {/* Contatos */}
          <div className="text-center md:text-left space-y-2 text-sm text-gray-300">
            <h3 className="text-white font-semibold text-lg mb-2">Nossos Contatos</h3>
            <p className="flex items-center justify-center md:justify-start gap-2">
              <FaMapMarkerAlt /> Ipatinga - MG
            </p>
            <p className="flex items-center justify-center md:justify-start gap-2">
              <FaPhone /> (31) 99312-7020
            </p>
            <p className="flex items-center justify-center md:justify-start gap-2">
              <FaEnvelope />
              <a href="mailto:higi.prime.vda@gmail.com" className="text-blue-100 hover:underline">
               higi.prime.vda@gmail.com
              </a>
            </p>
          </div>

          {/* Selos */}
{/* Container geral dos selos */}
<div className="flex flex-col md:flex-row md:items-center md:justify-end gap-4 mt-6 md:mt-0">

  {/* Grupo de selos visuais */}
  <div className="flex items-center justify-center gap-3">
    <img src={selo1} alt="Selo Qualidade em Atendimento" className="h-12 md:h-14" />
    <img src={selo2} alt="Selo Ecologicamente Correto" className="h-12 md:h-14" />
    <img src={selo3} alt="Selo Garantia 100%" className="h-12 md:h-14" />
  </div>

  {/* Selo ANVISA com texto ao lado */}
  <div className="flex items-center justify-center gap-2 mt-3 md:mt-0">
    <img
      src="/anvisa.png" // ou o caminho correto da imagem
      alt="Selo Anvisa"
      className="h-10"
    />
<p className="text-white text-xs leading-tight">
  <strong className="block">ANVISA</strong>
  <span className="block">USAMOS PRODUTOS</span>
  <span className="block">CERTIFICADOS</span>
</p>

  </div>

</div>

        </div>

        {/* Separador */}
        <div className="border-t border-black-500 my-6 w-4/5 mx-auto" />
      </footer>

      {/* Faixa com Laço e informações extras */}
      <FaixaComLaco />
    </>
  );
};

export default Rodape;
